import React, { useEffect, useState, useRef } from 'react';
import { useInView } from 'react-intersection-observer';
import CountUp from 'react-countup';
import { InfoIcon } from 'lucide-react';
export const TechnologySection = () => {
  const {
    ref,
    inView
  } = useInView({
    triggerOnce: true,
    threshold: 0.3
  });
  const sectionRef = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.15
    });
    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }
    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);
  return <section ref={sectionRef} className="relative py-20 px-6 md:px-12 overflow-hidden" style={{
    backgroundImage: 'url("https://cdn.shopify.com/s/files/1/0637/8940/0115/files/imgi_72_viacapbg.png?v=1763935444")',
    backgroundSize: 'cover',
    backgroundPosition: 'center'
  }} data-id="element-276">
      <div className="max-w-7xl mx-auto" data-id="element-277">
        <div className="relative rounded-3xl p-8 md:p-20 backdrop-blur-[37.5px]" style={{
        backgroundColor: 'rgba(73, 111, 88, 0.35)'
      }} data-id="element-278">
          <div className="grid lg:grid-cols-2 gap-12 items-start" data-id="element-279">
            {/* Left Content */}
            <div className={`transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'}`} data-id="element-280">
              <p className="text-white/90 text-xs font-light uppercase tracking-wider mb-6 font-mono" data-id="element-281">
                ● Advanced Technology
              </p>
              <h2 className="text-white text-3xl md:text-5xl font-light leading-tight mb-6" data-id="element-282">
                Most supplements don't survive digestion—
                <br className="md:hidden" data-id="element-283" />
                F&F Botanicals+ does.
              </h2>
              {/* Stats Box */}
              <div ref={ref} className="border border-white/25 rounded-2xl p-6 max-w-sm mb-6" data-id="element-284">
                <div className="flex items-center justify-between" data-id="element-285">
                  <p className="text-white text-sm leading-relaxed" data-id="element-286">
                    <span className="inline-flex items-center bg-white/20 px-2.5 py-0.5 rounded-full text-[10px] font-medium uppercase mr-2" data-id="element-287">
                      DS-01®
                    </span>
                    Increases
                    <br data-id="element-288" />
                    healthy bacteria by
                  </p>
                  <div className="flex items-center gap-1" data-id="element-289">
                    <InfoIcon className="w-4 h-4 text-white/60" data-id="element-290" />
                    <span className="text-white text-3xl font-light" data-id="element-291">
                      {inView ? <CountUp start={0} end={4.6} duration={2} decimals={1} decimal="." data-id="element-292" /> : '0.0'}
                      x<sup className="text-lg" data-id="element-293">*</sup>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {/* Right Content - Capsule Visualization */}
            <div className={`relative min-h-[400px] flex items-center justify-center transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 translate-x-12'}`} style={{
            transitionDelay: '200ms'
          }} data-id="element-294">
              {/* Center Capsule Image */}
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-10" data-id="element-295">
                <img src="https://cdn.shopify.com/s/files/1/0637/8940/0115/files/viacap-fallback.gif?v=1763923853" alt="Capsule technology" className="w-80 h-80 object-contain" data-id="element-296" />
              </div>
              {/* Outer Capsule Callout - Top Left */}
              <div className="absolute top-0 left-0 flex items-start gap-4 z-20" style={{
              transform: 'translateY(-10px)'
            }} data-id="element-297">
                <div className="max-w-[200px]" data-id="element-298">
                  <h3 className="text-white text-xs font-medium uppercase tracking-wide mb-2" data-id="element-299">
                    Outer Capsule
                  </h3>
                  <p className="text-white/90 text-xs leading-relaxed" data-id="element-300">
                    Shields active ingredients from stomach acid in the
                    digestive tract.
                  </p>
                </div>
                <div className="border-t border-dashed border-white/80 w-[70px] mt-6" data-id="element-301"></div>
              </div>
              {/* Inner Capsule Callout - Bottom Right */}
              <div className="absolute bottom-0 right-0 flex items-end gap-4 z-20" style={{
              transform: 'translateY(10px)'
            }} data-id="element-302">
                <div className="border-t border-dashed border-white/80 w-[70px] mb-6" data-id="element-303"></div>
                <div className="max-w-[200px]" data-id="element-304">
                  <h3 className="text-white text-xs font-medium uppercase tracking-wide mb-2" data-id="element-305">
                    Inner Capsule
                  </h3>
                  <p className="text-white/90 text-xs leading-relaxed" data-id="element-306">
                    Delivers biblically-sourced botanicals to the colon, where
                    they are needed most for optimal absorption.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};